import React, { useEffect, useState } from "react";
import Banner from "../../components/Banner/Banner";
import Nav from "../../components/Navbar/Nav";
import { useParams } from "react-router-dom";
import axios from "../../api/axios";
import apiUrl from "../../api/config.json";
import Row from "../../components/Movies/Row";
import Cast from "./Cast";

const API_KEY = apiUrl.APIKey;

function Movie() {
	const { id } = useParams();
	const movieId = id;

	const [movie, setMovie] = useState([]);
	const [similar, setSimilar] = useState("");

	const movieRequest = `/movie/${movieId}?api_key=${API_KEY}&language=en-US`;
	const tvRequest = `/tv/${movieId}?api_key=${API_KEY}&language=en-US`;
	const movieSimilar = `/movie/${movieId}/similar?api_key=${API_KEY}&num_votes=2000&language=en-US&sort=user_rating`;
	const tvSimilar = `/tv/${movieId}/similar?api_key=${API_KEY}&num_votes=2000&language=en-US&sort=user_rating`;

	useEffect(() => {
		async function getMovie() {
			try {
				let request = await axios.get(movieRequest);
				setMovie(request.data);
				return request;
			} catch (err) {
				if (err.response) {
					let request = await axios.get(tvRequest);
					setMovie(request.data);
					return request;
				} else {
					console.log("No Movie found?");
				}
			}
		}
		getMovie();

		async function getSimilar() {
			try {
				await axios.get(movieSimilar);
				setSimilar(movieSimilar);
			} catch (err) {
				if (err.response) {
					await axios.get(tvSimilar);
					setSimilar(tvSimilar);
				} else {
					console.log("No Movie found?");
				}
			}
		}
		getSimilar();
	}, [movieRequest, tvRequest, tvSimilar, movieSimilar]);

	return (
		<div>
			<Nav />
			<Banner movie={movie} />
			<Cast title="Cast" movieId={movieId} api={API_KEY} />
			<Row title="More Like This" fetchUrl={similar} isLargeRow />
		</div>
	);
}

export default Movie;
